export class MimePurposeToBeRenamed {
    public constructor(
        public mimePurpose: string,
        public newMimePurpose: string) {
    }
}
